<template>
  <div class="viewerList">
      <br />
      <div class="container">
    <div class="seasoncast-card col-12">
    <h1>{{ $t('MyAccount') }}</h1>
    <p>{{ $t('Email') }}: {{ viewer.email }}</p>
  
    <a v-on:click="logout()" href="#">[Logout]</a> <router-link to="/broadcaster/events">[Switch to Broadcaster]</router-link >

    </div>
    <br />
  
    <br />
    <div class="row ">
         <div class="col-12 col-md-6 ">
                 <div class=" "> 
                     <h5>My Highlights</h5><hr />
                        <div class="p-1">

    <div v-if="highlightList.length == 0">
        No Highlights. Go to a recording to create a highlight.
    </div>
    <div class="row">
    <div  v-for="highlight in highlightList" v-bind:key="highlight.id" class=" col-md-6 col-12 p-2">
        <div class="cardDisplay" style="cursor:pointer;" @click="$router.push('/highlight/'+highlight.id)" >
        <img style="width:100%; height:auto; border-radius:5px;margin-bottom:10px" v-bind:src="'https://cdn.mylivegame.com/file/mylivegame/highlights/'+highlight.publisher.id+'/'+highlight.id+'/thumbnail.jpg'" />
        <h5 v-text="highlight.title"></h5>
        {{ highlight.origin.title}}
       </div>
    </div>
    </div>
     </div>
             </div>
    </div>
        <div class="col-12 col-md-6 ">
                 <div class=" "> 
                     <h5>My SeasonPass's</h5><hr />
                        <div class="p-1">

    <div v-if="seasonPassList.length == 0">
        No SeasonPass's. Go to the channel to start the purchase process.
    </div>
    <div class="row">
    <div  v-for="seasonPass in seasonPassList" v-bind:key="seasonPass.id" class=" col-md-6 col-12 p-2">
        <div class="cardDisplay">
        <h5 v-text="seasonPass.name"></h5>
        <p >Vaild: {{ seasonPass.isExpired ? "No" : "Yes"}} <br />
        {{ !seasonPass.isExpired ? "Pass Expires: "+parseTimeStamp(seasonPass.expire) : "Expired: "+ parseTimeStamp(seasonPass.expire)}}</p>
        <br />
        
            <button v-if="!seasonPass.isExpired" v-on:click="goToChannel(seasonPass.channel_id)" type="button"  class="btn btn-dark btn-block">{{  $t('GoToChannel') }}</button>

             <router-link v-if="seasonPass.isExpired" v-bind:to="'/viewer/lock/'+seasonPass.channel_id" v-on:click="goToChannel(seasonPass.channel_id)" type="button"  class="btn btn-secondary btn-block">Purchase New Pass</router-link>
        </div>
    </div>
    </div>
     </div>
             </div>
    </div>
    </div>
    </div>
  </div>
</template>

<script>

  import Swal from "sweetalert2"
  import axios from "axios"
  import cookie from "cookie.js"
  import jwt_decode from "jwt-decode";

let API = "https://app.seasoncast.com/"
//let API = "http://localhost:8089/"

export default {
 data: function () {
    return {
      seasonPassList: [],
      highlightList: [],
      apiToken: null,
      apiEmail: null,
      viewer: null
    }
  },
 created: async function () {
    console.log("create call")
    let getViewerToken = cookie.get("viewer-token")
    if (!getViewerToken){
        this.$router.push('/viewer/login');
    }

    this.apiToken = getViewerToken
    this.apiEmail = cookie.get("viewer-email")
    this.viewer = jwt_decode(getViewerToken)

    this.getAccount()
    this.getAccountHighlights()
},
 methods: {
     goToChannel: async function (url) {
         console.log(url)
         location.href = "https://"+url+".mylivegame.com/transfer/seasonPassHolder?token="+this.apiToken
     },
     logout: async function () {
     cookie.remove("viewer-token", { path: '/' })
     cookie.remove("viewer-email", { path: '/' })
         cookie.remove("viewer-token")
     cookie.remove("viewer-email")
     this.$router.push('/viewer/login');
     },
    getAccount: async function () {
      
    let getEventResponse = await axios.post(API+ "v2/viewer/account", {
    email: this.apiEmail,
    token:  this.apiToken
  }) 

  let responseData = getEventResponse.data

  if (!responseData.success){
       Swal.fire({
  icon: 'error',
  title: 'Account Error',
  text: 'server error: '+JSON.stringify(responseData.reason),
  footer: 'Try action later or refresh page'
})
  }
console.log(responseData)
  this.seasonPassList = responseData.result



    },
      getAccountHighlights: async function () {
      
    let getEventResponse = await axios.post(API+ "v2/viewer/highlight/list", {
    email: this.apiEmail,
    token:  this.apiToken
  }) 

  let responseData = getEventResponse.data

  
console.log(responseData)
  this.highlightList = responseData.result



    },
    parseTimeStamp(ts){
      return new Date(ts*1000).toLocaleDateString()
    },
 }
}
    </script>
    <style lang="css" scoped>
    .cardDisplay {
          border-style: solid;
  border-width: 1px;
   border-radius: 5px;
   border-color: rgb(226, 226, 226);
   padding: 10px;
   text-align: center;
   background-color: white;
    }
    </style>>
